export default {
      id: "newsletter-usage",
      viewBox: "0 0 46 50",
      url: "../dist/images/" + "sprite.svg#newsletter-usage",
      toString: function () {
        return this.url;
      }
    }